// Choropleth SVG motif — purely decorative abstract data graphic.
// No real statistics, no fabricated client data.
export default function ChoroplethMotif({ className = "" }) {
  // Five abstract polygon "regions" + node dots, fills derived from continuum gradient stops
  const stops = ["#0A1224", "#3B4C68", "#8898AA", "#D9A05B", "#FF8A00"];
  return (
    <svg
      viewBox="0 0 480 360"
      className={className}
      role="img"
      aria-label="Abstract data graphic representing community regions"
      data-testid="choropleth-motif"
    >
      <defs>
        <linearGradient id="cg" x1="0" x2="1">
          {stops.map((c, i) => (
            <stop key={i} offset={`${(i / (stops.length - 1)) * 100}%`} stopColor={c} />
          ))}
        </linearGradient>
        <pattern id="grid" width="20" height="20" patternUnits="userSpaceOnUse">
          <path d="M 20 0 L 0 0 0 20" fill="none" stroke="rgba(255,255,255,0.05)" strokeWidth="1" />
        </pattern>
      </defs>
      <rect width="480" height="360" fill="#0A1224" />
      <rect width="480" height="360" fill="url(#grid)" />

      {/* Abstract polygon regions */}
      <path d="M40,60 L160,40 L200,140 L100,180 Z" fill={stops[0]} stroke="#FF8A00" strokeWidth="1" opacity="0.95" />
      <path d="M160,40 L320,70 L290,170 L200,140 Z" fill={stops[1]} stroke="#FF8A00" strokeWidth="1" opacity="0.9" />
      <path d="M320,70 L440,90 L420,200 L290,170 Z" fill={stops[2]} stroke="#FF8A00" strokeWidth="1" opacity="0.9" />
      <path d="M100,180 L200,140 L290,170 L260,260 L120,280 Z" fill={stops[3]} stroke="#FF8A00" strokeWidth="1" opacity="0.95" />
      <path d="M260,260 L420,200 L440,320 L300,330 Z" fill={stops[4]} stroke="#FF8A00" strokeWidth="1.5" opacity="1" />

      {/* Indicator nodes */}
      {[
        [110, 110], [240, 90], [380, 130], [180, 220], [340, 260], [110, 250],
      ].map(([x, y], i) => (
        <g key={i}>
          <circle cx={x} cy={y} r="6" fill="#FFFFFF" />
          <circle cx={x} cy={y} r="2.5" fill="#FF8A00" />
        </g>
      ))}

      {/* Flow lines */}
      <path d="M110,110 Q200,40 380,130" fill="none" stroke="#FF8A00" strokeWidth="1.5" className="flow-line" />
      <path d="M180,220 Q260,160 340,260" fill="none" stroke="#FFFFFF" strokeWidth="1" opacity="0.5" className="flow-line" />
    </svg>
  );
}
